import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { defaultSortComparator } from '@components/DataGrid/types';
import RenderHeader from '@components/DataGrid/RenderHeader';
import { HeaderSubLabel, SubColumnDef, subColumnField } from '@components/DataGrid/subColumns';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import { GridColDefExtended } from '@mui/x-data-grid-pro';
import DriverCell from '../Cells/Driver';

const driverField = 'Driver';

/** Sub-values of the Driver column sortable via hidden companion columns */
const driverSubColumns: SubColumnDef<DispatchLeg>[] = [{ key: 'truck', label: 'Truck', valueGetter: (row) => row.tractorId }];

const driverSubLabels: HeaderSubLabel[] = driverSubColumns.map((sub) => ({
  label: sub.label,
  field: subColumnField(driverField, sub.key)
}));

const driverDefinition: GridColDefExtended<DispatchLeg> = {
  field: driverField,
  minWidth: 75,
  width: 175,
  headerName: 'Driver|||Truck',
  subColumns: driverSubColumns,
  /** Mobile cards invoke renderHeader without params (RenderCardCell), so they fall back to the
   * static secondaryText instead of mounting the grid-subscribing sort labels per card */
  renderHeader: (params) => (
    <RenderHeader
      primaryText='Driver'
      subLabels={params.field ? driverSubLabels : undefined}
      secondaryText='Truck'
    />
  ),
  renderCell: DriverCell,
  disableReorder: true,
  getApplyQuickFilterFn: (value: string) => {
    return (_, row): boolean =>
      applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
        const { drvName, tractorId } = row;
        return caseInsensitiveIncludes(value, [drvName, tractorId]);
      });
  },
  valueGetter: (_, row: DispatchLeg) => `${row.drvName ?? ''}|||${row.tractorId ?? ''}`,
  sortable: true,
  sortComparator: (v1, v2, cellParams1) => {
    if (typeof v1 === 'string' && typeof v2 === 'string') {
      const [v1Driver, v1Tractor] = v1.split('|||');
      const [v2Driver, v2Tractor] = v2.split('|||');

      return (
        defaultSortComparator(v1Driver, v2Driver, cellParams1) ||
        defaultSortComparator(v1Tractor, v2Tractor, cellParams1)
      );
    }

    return 0;
  }
};

export default driverDefinition;
